/**
 * Statistics: Clicks per country table with 1 row per country
 * @param {DataStore} store - storage
 * @param {object} translations - translations / wording
 * @param {Pagination} pagination - pagination
 */
class ClicksPerCountry {
  constructor(args) {
    this.store = args.store;
    this.translations = args.translations;
    this.pagination = args.pagination;
    this.outerContainer = document.querySelector('.clicks-per-country');
    this.loader = document.querySelector('#loading-overlay');
    this.countryRows = this.outerContainer.querySelector('.country-rows');
    this.countries = [];
    this.pageIndex = 0;
    this.countriesPerPage = 5;

    this.addEvents();
  }

  addEvents() {
    ['init', 'update'].map(eventType => {
      this.store.subscribe(eventType, e => {
        const data = e.completeList.clicks.slice(0);
        let allClicks = 0;
        let max = 0;
        let aggregated = {};

        data.forEach(click => {
          const amount = parseInt(click.amount);
          allClicks += amount;

          const label = click.country_name ? click.country_name : this.translations.unknown;

          if (aggregated[label]) {
            aggregated[label] += amount;
          } else {
            aggregated[label] = amount;
          }
        });

        Object.keys(aggregated).map(label => {
          const amount = parseInt(aggregated[label]);
          max = max < amount ? amount : max;
        });

        this.countries = Object.keys(aggregated).reduce((countries, label) => {
          const amount = parseInt(aggregated[label]);

          countries.push({
            countryName: label,
            amount: amount,
            pct: (amount / allClicks * 100).toFixed(2),
            width: amount / (max / 100)
          });

          return countries;
        }, []);

        this.countries.sort((a, b) => b.amount - a.amount);

        this.render();
      });
    });

    this.pagination.subscribe('pageChange', p => {
      this.pageIndex = p[0];
      this.render();
    });
  }

  get visibleCountries() {
    return this.countries.slice(this.pageIndex * this.countriesPerPage, this.pageIndex * this.countriesPerPage + this.countriesPerPage);
  }

  render() {
    this.countryRows.innerHTML = '';
    this.pageIndex = this.pagination.update(this.countries.length, this.countriesPerPage);

    this.visibleCountries.forEach(countryData => {
      const countryRowElement = document.createElement('div');
      this.countryRows.insertAdjacentElement('beforeend', countryRowElement);

      new CountryStatisticRow({
        parent: this,
        element: countryRowElement,
        data: countryData
      });
    });
  }
}

/**
 * Country Table Row
 * @class
 * @param { object } args.parent - The instance of the parent class
 * @param { object } args.element - The country row element
 * @param { object } args.data - The country data JSON
 */
class CountryStatisticRow {
  constructor(args) {
    this.parent = args.parent;
    this.element = args.element;
    this.data = args.data;

    this.render();
  }

  render() {
    this.element.innerHTML = this.template;
    this.element.classList.add('list-row');
  }

  get template() {
    return `
      <div class="country-name">${this.data.countryName}</div>
      <div class="clicks-bar">
        <div class="bar" style="width:${this.data.width}%">
          <span>${this.data.pct}%</span>
        </div>
      </div>
    `;
  }
}

export default ClicksPerCountry;